import React from 'react';
import { ActionButton } from '../../action-button/ActionButton';
import type {
  BookingPurchaseDialogData,
  BookingPurchaseDocumentLink,
} from '../BookingPurchaseDialog.types';

type Props = Readonly<{
  footerButtons?: BookingPurchaseDialogData['footerButtons'];
  documentLinks?: BookingPurchaseDialogData['documentLinks'];
}>;

function DocumentLinks({
  links,
}: Readonly<{ links: BookingPurchaseDocumentLink[] }>) {
  if (links.length === 0) {
    return null;
  }

  return (
    <ul className="list">
      {links.map((link) => (
        <li key={link.label} className="document-link">
          <button
            type="button"
            className="warning__message"
            onClick={() => link.onClick?.()}
          >
            {link.label}
          </button>
        </li>
      ))}
    </ul>
  );
}

export function DialogFooter({
  footerButtons = [],
  documentLinks = [],
}: Props) {
  if (footerButtons.length === 0 && documentLinks.length === 0) {
    return null;
  }

  return (
    <div className="content-group modal-book-button">
      <DocumentLinks links={documentLinks} />
      {footerButtons.map((button, index) => (
        <div
          key={button.id || button.dataTestId || `footer-${index}`}
          className="book-buy-action-button"
        >
          <ActionButton data={button} />
        </div>
      ))}
    </div>
  );
}
